import React from "react";
import { Link } from "react-router-dom";
import {
  CollectJobSheetMainPage,
  CorrectiveDetailPage,
  CreateJobSheetPage,
  MonitorPage,
  ProductManagePage,
  ProductSearchPage,
  StoreTransferPage,
} from "../utils/PathConfig";
import image from "../assets/images/home.png";
import * as Icon from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";


const Mainpage = () => {
  const { t } = useTranslation();
  
  return (
    <> 
    </>
  );
};

export default Mainpage;
